export const formatCurrency = (amount) => {
    return new Intl.NumberFormat('ja-JP').format(amount);
};

// 全角数字・全角英字を半角に変換
export const toHalfWidth = (str) => {
    return str.replace(/[０-９Ａ-Ｚａ-ｚ]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 0xFEE0));
};

// 金額文字列をパース（カンマ・全角対応）
export const parseAmount = (str) => {
    if (typeof str === 'number') return str;
    if (!str) return 0;
    const normalized = toHalfWidth(String(str)).replace(/,/g, '').replace(/[^0-9.-]/g, '');
    return parseInt(normalized, 10) || 0;
};

// 金額入力用フォーマット（カンマ区切り）
export const formatAmountInput = (amount) => {
    if (!amount || amount === 0 || amount === '') return '';
    return new Intl.NumberFormat('ja-JP').format(amount);
};

export const generateId = () => {
    return Date.now().toString(36) + Math.random().toString(36).substr(2);
};
